import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-tous-bn-recep',
  templateUrl: './tous-bn-recep.component.html',
  styleUrls: ['./tous-bn-recep.component.scss']
})
export class TousBnRecepComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        console.log('TousCmdComponent initialized');
        this.dataService.filterBonReceptionByStatus('Tous');

    }

}
